<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.5">
<circle cx="12" cy="12" r="11.5" fill="white" stroke="#14537D"/>
<path d="M17.3333 5.33301H6.66668C5.93334 5.33301 5.33334 5.93301 5.33334 6.66634V18.6663L8.00001 15.9997H17.3333C18.0667 15.9997 18.6667 15.3997 18.6667 14.6663V6.66634C18.6667 5.93301 18.0667 5.33301 17.3333 5.33301ZM17.3333 14.6663H8.00001L6.66668 15.9997V6.66634H17.3333V14.6663Z" fill="#14537D"/>
</g>
</svg>
